import { useState, useEffect } from 'react';
import { employeesApi } from '../services/api';

export const useEmployeePhoto = (azureId) => {
  const [photoUrl, setPhotoUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isObjectUrl, setIsObjectUrl] = useState(false);

  useEffect(() => {
    if (!azureId) {
      setIsLoading(false);
      return;
    }
    
    const fetchPhoto = async () => {
      try {
        // Use the cached implementation which already handles localStorage caching
        const response = await employeesApi.getEmployeePhoto(azureId);

        if (response) {
          setPhotoUrl(response);
          setIsObjectUrl(true); // Mark as object URL if coming from API
        } else {
          setPhotoUrl(null);
          setIsObjectUrl(false);
        }
      } catch (error) {
        console.error('Error fetching employee photo:', error);
        setPhotoUrl(null);
        setIsObjectUrl(false);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPhoto();

    // Cleanup function to revoke object URL when component unmounts
    return () => {
      if (photoUrl && isObjectUrl) {
        URL.revokeObjectURL(photoUrl);
      }
    };
  }, [azureId]);

  return { photoUrl, isLoading };
}; 